import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionDayTripPlanKeyVisual } from "./key-visual";
import { QuestionDayTripPlanMainTarget } from "./main-target";
import { QuestionDayTripPlanName } from "./name";

import type { DayTripPlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	base: DayTripPlanCategoriesAndManagerStore["base"];

	hotelID: string;
	planID: string;
};

export const QuestionDayTripPlanBase = ({ base, hotelID, planID }: Props) => {
	const ownerID = hotelID;
	const resourceID = planID;

	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={base}>
			<QuestionDayTripPlanName />
			<QuestionDayTripPlanMainTarget />
			<QuestionDayTripPlanKeyVisual ownerID={ownerID} resourceID={resourceID} />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionDayTripPlanBase.displayName = "QuestionDayTripPlanBase";
